let isInitialized = false
// googleAdsTag.js
let gtagLoadPromise = null
const configuredIds = new Set()
let currentAdsId = null

function ensureGtagStub() {
    if (typeof window === 'undefined') return
    window.dataLayer = window.dataLayer || []
    if (typeof window.gtag !== 'function') {
        window.gtag = function gtag() {
            window.dataLayer.push(arguments)
        }
        window.gtag('js', new Date())
    }
}

function loadGtagScriptOnce(mainId) {
    if (typeof window === 'undefined') return Promise.resolve()
    if (gtagLoadPromise) return gtagLoadPromise

    ensureGtagStub()

    gtagLoadPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-gtag-aw="true"]')
        if (existing) {
            resolve()
            return
        }
        const script = document.createElement('script')
        script.async = true
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
            mainId || 'AW-INIT',
        )}`
        script.setAttribute('data-gtag-aw', 'true')
        script.onload = () => resolve()
        script.onerror = (e) => reject(e)
        document.head.appendChild(script)
    })

    return gtagLoadPromise
}

export async function initGoogleAdsTag({ adsId } = {}) {
    if (typeof window === 'undefined') return
    if (!adsId) {
        console.warn('[AW] initGoogleAdsTag: adsId is empty')
        return
    }

    currentAdsId = adsId

    await loadGtagScriptOnce(adsId)
    ensureGtagStub()

    if (!configuredIds.has(adsId)) {
        window.gtag('config', adsId)
        configuredIds.add(adsId)
    }
}

export function sendConversion(transactionId = '', label, adsIdOverride) {
    if (typeof window === 'undefined') return

    const adsId = adsIdOverride || currentAdsId

    if (!adsId || !adsId.startsWith('AW-')) {
        console.warn(
            '[AW] sendConversion: invalid adsId. Call initGoogleAdsTag({ adsId }) first or pass adsIdOverride.',
        )
        return
    }
    if (!label) {
        console.warn('[AW] sendConversion: conversion label is required.')
        return
    }

    const payload = {
        send_to: `${adsId}/${label}`,
        transaction_id: transactionId || '',
    }

    if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', payload)
    } else if (gtagLoadPromise) {
        gtagLoadPromise.then(() => {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'conversion', payload)
            }
        })
    }
}

export function isGtagReady() {
    return typeof window !== 'undefined' && typeof window.gtag === 'function'
}

export function initGA(measurementId) {
    if (!measurementId || isInitialized) return
    isInitialized = true

    // Load the gtag script dynamically
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    document.head.appendChild(script)

    // Initialize gtag
    script.onload = () => {
        window.dataLayer = window.dataLayer || []
        function gtag() {
            window.dataLayer.push(arguments)
        }
        window.gtag = gtag

        gtag('js', new Date())
        gtag('config', measurementId)
    }
}

export function trackPageView(path) {
    if (window.gtag) {
        window.gtag('config', process.env.REACT_APP_GA_ID, {
            page_path: path,
        })
    }
}

export function trackEvent({ action, category, label, value }) {
    if (window.gtag) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        })
    }
}
